import createCachedSelector from 're-reselect';
import { createSelector } from 'reselect';

import { PrCommentJiraIssue } from 'src/redux/jira/types';
import { getJiraSlice } from 'src/selectors/state-slicing-selectors';
import { BucketState } from 'src/types/state';

export const getPullRequestJiraIssuesFetchedStatus = createSelector(
  getJiraSlice,
  state => state.pullRequestJiraIssues.jiraIssuesFetchedStatus
);

export const getPullRequestJiraIssues = createSelector(
  getJiraSlice,
  state => state.pullRequestJiraIssues.jiraIssues
);
export const getIssueTransitionForm = createSelector(
  getJiraSlice,
  state => state.pullRequestJiraIssues.issueTransitionFormData
);

export const getPullRequestJiraIssuesState = createSelector(
  getJiraSlice,
  state => state.pullRequestJiraIssues
);

export const getJiraIssueConnectedSites = createSelector(
  getJiraSlice,
  state => state.createJiraIssue.connectedSites
);

export const getJiraIssueFetchedStatus = createSelector(
  getJiraSlice,
  state => state.createJiraIssue.connectedSitesFetchedStatus
);

export const getPullRequestJiraIssuesForComment = createCachedSelector(
  getPullRequestJiraIssues,
  (_state: BucketState, commentId: number) => commentId,
  (issues: PrCommentJiraIssue[], commentId: number) => {
    return issues.filter(issue => issue.commentId === commentId);
  }
)((_state, commentId: number) => commentId);

export const getPullRequestJiraIssuesByType = createCachedSelector(
  getPullRequestJiraIssues,
  (_state: BucketState, type: string) => type,
  (issues: PrCommentJiraIssue[], type: string) => {
    return issues.filter(issue => issue.type === type);
  }
)((_state, type: string) => type);

export const getCreateJiraIssuePreferences = createSelector(
  getJiraSlice,
  state => state.createJiraIssue.preferences
);

export const getCreatedJiraIssue = createSelector(
  getJiraSlice,
  state => state.createJiraIssue.jiraTabCreateForm.issue
);
